import { Brain, Smartphone, Flame, Sparkles } from "lucide-react";

const items = [
    { icon: Brain, label: "A du mal à se concentrer ?" },
    { icon: Smartphone, label: "Est accro aux écrans ?" },
    { icon: Flame, label: "Se met en colère ou abandonne facilement ?" },
    { icon: Sparkles, label: "A du potentiel mais ne l'exploite pas ?" },
];

export default function PainPoints() {
    return (
        <section data-testid="painpoints-section" className="py-24 sm:py-28 bg-white relative">
            <div className="container-wide">
                <div className="max-w-3xl">
                    <span className="eyebrow-pink">Vous vous reconnaissez ?</span>
                    <h2 data-testid="painpoints-title" className="display-2 mt-4">
                        Votre enfant<span className="text-brand-500">...</span>
                    </h2>
                </div>

                <ul className="mt-14 grid sm:grid-cols-2 gap-5">
                    {items.map(({ icon: Icon, label }, i) => (
                        <li
                            key={label}
                            data-testid={`painpoint-${i}`}
                            className="group soft-card flex items-center gap-5 px-6 py-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand-200"
                        >
                            <span className="h-12 w-12 rounded-2xl bg-brand-50 grid place-items-center text-brand-600 transition-colors group-hover:bg-brand-500 group-hover:text-white shrink-0">
                                <Icon className="h-5 w-5" strokeWidth={2} />
                            </span>
                            <p className="text-base sm:text-lg font-medium text-ink-800">{label}</p>
                        </li>
                    ))}
                </ul>

                <p className="mt-12 text-center text-ink-600 text-base sm:text-lg max-w-2xl mx-auto">
                    Si vous avez répondu <span className="text-brand-600 font-semibold">oui</span> à au moins une
                    question, notre méthode peut vous aider.
                </p>
            </div>
        </section>
    );
}
